import { createInjectionKey as e } from "./ghl-ui.es896.js";
const t = e("n-internal-select-menu"), o = e("n-internal-select-menu-body");
export {
  o as internalSelectionMenuBodyInjectionKey,
  t as internalSelectionMenuInjectionKey
};
